import { Button, Group, Select, TextInput } from "@mantine/core";
import { StatsTrendControls } from "../../../components/StatsTrendControls.tsx";
import type { AnalyticsStatsHook } from "./useAnalyticsStats.ts";

type Props = {
  readonly stats: AnalyticsStatsHook;
  /** 是否显示广告 ID 筛选（广告页自有维度时可关） */
  readonly showAdId?: boolean;
  readonly onExport?: () => void;
  readonly exportDisabled?: boolean;
};

export function AnalyticsStatsFilters({
  stats,
  showAdId = true,
  onExport,
  exportDisabled = false,
}: Props) {
  return (
    <Group justify="space-between" wrap="wrap" align="flex-end">
      <Group wrap="wrap" align="flex-end" gap="md">
        <StatsTrendControls
          range={stats.range}
          granularity={stats.granularity}
          onRangeChange={stats.setRange}
          onGranularityChange={stats.setGranularity}
        />
        <Select
          label="群组"
          placeholder="全部群组"
          data={stats.chatOptions}
          value={stats.chatId}
          onChange={stats.setChatId}
          searchable
          clearable
          nothingFoundMessage="无匹配群组"
          disabled={stats.chatsLoading}
          w={260}
        />
        {showAdId ? (
          <TextInput
            label="广告 ID"
            placeholder="留空=全部；精确匹配"
            value={stats.adIdInput}
            onChange={(e) => stats.setAdIdInput(e.currentTarget.value)}
            w={300}
          />
        ) : null}
      </Group>
      {onExport !== undefined ? (
        <Button variant="outline" onClick={onExport} disabled={exportDisabled}>
          导出 CSV
        </Button>
      ) : null}
    </Group>
  );
}
